// 自有品牌
const map = {
  materialStore: () => import('@/views/ownbrand/MaterialStore'),
  devProofSheet: () => import('@/views/ownbrand/DevProofSheet'),
  resProofSheet: () => import('@/views/ownbrand/ResProofSheet'),
  formulaLibrary: () => import('@/views/ownbrand/FormulaLibrary')
}

export default map
